import { useEffect, useState } from "react";
import { useMountEffect } from "primereact/hooks";
import { connect } from "react-redux";
import { useIntl } from "react-intl";
import { useNavigate } from "react-router-dom";
import {
  listRequest,
  updateStatusRequest,
} from "../../../../store/slices/notificationSlice";
import CustomBreadCrumbs from "../../../common/breadcrumbs";
import { InputSwitch } from "primereact/inputswitch";
import * as RoleHelper from "../../../../helpers/RoleHelper";
import {
  AccessScopeConstants,
  RouteConstants,
  SavedReportConstants,
} from "../../../../constants";
import * as CertificateBatchConstants from "../../../../constants/CertificateBatchConstants";
import { classNames } from "primereact/utils";
import TooltipButton, { TooltipTarget } from "../../../common/tooltipButton";
import { TextInput, SwitchInput, TextInputNoti } from "../../../common/fields";
import { OverlayPanel } from "primereact/overlaypanel";
import { Tooltip } from "primereact/tooltip";
import { useRef } from "react";
import { Field } from "react-final-form";
import { set } from "lodash";
import { emailBannerDetailsRequest } from "../../../../store/slices/globalSlice";
import { select } from "redux-saga/effects";

export const NotificationList = ({
  labels,
  list = [],
  action = "",
  requesting = false,
  listRequest,
  updateStatusRequest,
  user,
}) => {
  const intl = useIntl();
  const navigate = useNavigate();
  const [openSections, setOpenSections] = useState({});
  const [search, setSearch] = useState("");
  const [namePattern, setNamePattern] = useState("");
  const [createdByNamePattern, setCreatedByNamePattern] = useState("");
  const [selectedNoteId, setSelectedNoteId] = useState(null);
  const { role } = user || {};
  const canUpdate = RoleHelper.checkRoleScope(
    role?.scope,
    AccessScopeConstants.EnterpriseAccess,
    AccessScopeConstants.UpdateScope
  );
  // Add new and Clone both create a notification
  // (NotificationController.CreateNewNotificationRequest), which the API now
  // checks Enterprise access Create for (P-UI-7).
  const canCreate = RoleHelper.checkRoleScope(
    role?.scope,
    AccessScopeConstants.EnterpriseAccess,
    AccessScopeConstants.CreateScope
  );
  const op = useRef(null);

  const todaysDate = new Date();



  useMountEffect(() => {
    listRequest();
  });

  useEffect(() => {
    if (action === "update" && !requesting) {
      listRequest();
    }
  }, [action, requesting]);

  const toggleSection = (id) => {
    setOpenSections((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  const [selectedOverlay, setSelectedOverlay] = useState(null);


  useEffect(()=>{
    if(list.length){
       const overlayItem = list?.find((item)=>{
      if(openSections[item.id]){
       const selectedNoteType=item.name;
       const selectedNote = item?.notifications?.find((n) => n.id === selectedNoteId)
       if(selectedNote){
        return item;
       }
      }
    })


    const note=overlayItem?.notifications?.find((n) => n.id === selectedNoteId)

    setSelectedOverlay({
      name:overlayItem?.name,
      notification:note

    })
    }
  },[selectedNoteId])


  const expandAll = () => {
    const all = {};
    list?.forEach((item) => {
      if (item.notifications?.length > 0) all[item.id] = true;
    });
    setOpenSections(all);
  };

  const disabldNotification=(name,date)=>{
    if(name!=="others"){
      return false; 
    }else if(name=="others" && todaysDate<new Date(date)){
      return false
    }else{
      return true;
    }
  }

  const disabledUserCreationNotificatoin = (name)=> {
    if (name.toLowerCase() === "self registration with verification"){
      return true;
    } else if (name.toLowerCase() === "self registration without verification"){
      return true;
    }
    return false;
  }

  // Emails that are always on (the API refuses to switch them off), with the
  // tooltip that says why.
  const ALWAYS_ON_MESSAGES = {
    [SavedReportConstants.NOTIFICATION_TYPE_SCHEDULED_REPORT]:
      "saved_report_email_always_on",
    [CertificateBatchConstants.NOTIFICATION_TYPE_CERTIFICATES_READY]:
      "certificate_batch_email_always_on",
  };
  const isAlwaysOn = (note) => Boolean(ALWAYS_ON_MESSAGES[note.type]);

  const collapseAll = () => {
    setOpenSections({});
  };

  const totalExpandable =
    list?.length > 0
      ? list?.filter((item) => item.notifications?.length > 0).length
      : [];
  const openedCount = Object.keys(openSections).length;

  // ✅ Only true if *all* are open
  const allOpen = openedCount === totalExpandable;

  // filter list by search
  // const filteredList = list?.filter(
  //   (item) =>
  //     item.name.toLowerCase().includes(search.toLowerCase()) ||
  //     item.notifications?.some((n) =>
  //       n.name.toLowerCase().includes(search.toLowerCase())
  //     )
  // );

  const filteredList =
    list?.length > 0
      ? list?.filter(
          (item) =>
            item.name.toLowerCase().includes(namePattern.toLowerCase()) ||
            item.notifications?.some((n) =>
              n.name.toLowerCase().includes(namePattern.toLowerCase())
            )
        )
      : [];
  const onAddClick = () => {
    navigate(RouteConstants.APP_ROUTE_NOTIFICATIONS_BUILDER_ADD, {
      state: { isEdit: false },
    });
  };
  return (
    <div>
      <CustomBreadCrumbs labels={labels} navigate={navigate} />

      <div className="edexlms-page-content">
        {/* <div
          className="edexlms-page-header"
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div className="edexlms-page-title" style={{ fontSize: "20px", fontWeight: "600" }}>
            {intl.formatMessage({ id: "Notification Builder" })}
          </div>

          <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
            
            <input
              type="text"
              placeholder="Search"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              style={{
                padding: "6px 10px",
                border: "1px solid #ccc",
                borderRadius: "6px",
              }}
            />
            
            <button
              style={{
                background: "black",
                color: "white",
                border: "none",
                borderRadius: "6px",
                padding: "6px 12px",
                cursor: "pointer",
              }}
            >
              + Add New
            </button>
            
            <span
              onClick={() =>
                Object.keys(openSections).length ? collapseAll() : expandAll()
              }
              style={{
                color: "#007bff",
                cursor: "pointer",
                fontSize: "14px",
              }}
            >
              {Object.keys(openSections).length ? "Collapse All" : "Expand All"}
            </span>
          </div>
        </div> */}
        <div className="edexlms-page-header">
          <div className="edexlms-page-title">
            {intl.formatMessage({ id: "notification_builder" })}
          </div>
          <div className="edexlms-page-actions">
            <TooltipButton
              label={intl.formatMessage({ id: "add_new" })}
              icon="pi pi-plus"
              onClick={onAddClick}
              size="small"
              type="button"
              disabled={!canCreate}
              tooltipOptions={{ showOnDisabled: true, position: "bottom" }}
              tooltip={
                canCreate ? "" : intl.formatMessage({ id: "no_permission" })
              }
            />
          </div>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "1rem",
          }}
        >
          <div className="edexlms-search-filter-bar">
            <TextInputNoti
              iconPosition="left"
              icon="pi-search"
              placeholder={intl.formatMessage({ id: "search" })}
              input={{
                name: "search",
                value: namePattern,
                onChange: (value) => setNamePattern(value),
              }}
            />
          </div>
          {/* <span
              onClick={() =>
                Object.keys(openSections).length ? collapseAll() : expandAll()
              }
              style={{
                color: "#007bff",
                cursor: "pointer",
                fontSize: "14px",
                fontWeight:"500",
                marginLeft:"20px",
                marginTop:"0.1px"
              }}
            >
              {Object.keys(openSections).length ? "Collapse All" : "Expand All"}
            </span> */}
          <span
            onClick={() => (allOpen ? collapseAll() : expandAll())}
            style={{
              color: "#007bff",
              cursor: "pointer",
              fontSize: "14px",
              fontWeight: "500",
              marginLeft: "20px",
              marginTop: "0.1px",
            }}
          >
            {allOpen ? "Collapse All" : "Expand All"}
          </span>
        </div>

        {/* Body */}
        <div
          className="edexlms-page-body notifications"
          // style={{
          //   marginTop: "20px",
          //   maxHeight: "60vh",
          //   overflowY: "auto",
          // }}
          style={{
            height: "calc(100vh - 64px - 20px - 45px - 40px - 14px - 40px)", // adjust numbers if your header/footer heights differ
            overflowY: "auto",
            marginTop: "20px",
          }}
        >
          {filteredList?.map((item) => {
            return (
              <div
                key={item.id}
                style={{
                  borderBottom: "1px solid #eee",
                  marginBottom: "8px",
                  paddingBottom: "8px",
                }}
              >
                {/* Main label row */}
                <div
                  onClick={() =>
                    item.notifications?.length > 0 && toggleSection(item.id)
                  }
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    cursor:
                      item.notifications?.length > 0 ? "pointer" : "default",
                    fontWeight: "400",
                    fontSize: "16px",
                    // color: "#333",
                    color: "#4b5563",
                    padding: "6px 0",
                  }}
                >
                  <span>{item.name}</span>
                  {item.notifications?.length > 0 && (
                    <span style={{ fontSize: "12px" }}>
                      <i
                        className={classNames("pi", {
                          "pi-angle-up": openSections[item.id],
                          "pi-angle-down": !openSections[item.id],
                        })}
                        style={{
                          display: "inline-block",
                          fontSize: "1.2rem",
                          fontWeight: "normal",
                          color: "#666",
                          marginLeft: "0px",
                          marginRight: "12px",
                          verticalAlign: "middle",
                        }}
                      ></i>
                    </span>
                  )}
                </div>

                {/* Notifications list */}
                {openSections[item.id] && item.notifications?.length > 0 && (
                  <div style={{ marginTop: "6px", paddingLeft: "20px" }}>
                    {item.notifications.map((note) => {
              
                     if(note.name.toLowerCase()!=="program completed"){
                       return (
                        <div
                          data-testid="notification-row"
                          key={note.id}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            padding: "8px 0",
                            fontSize: "14px",
                            color: "#555",
                          }}
                        >
                          {/* Column 1 - Name */}
                          <div style={{ flex: 1, color: "#4b5563" }}>
                            • {note.name}
                          </div>

                          {/* Column 2 - Toggle */}
                          {/* <div style={{ width: "80px", textAlign: "center" }}>
          <InputSwitch
            tooltipOptions={{
              showOnDisabled: true,
              position: "bottom",
            }}
            tooltip={
              canUpdate ? "" : intl.formatMessage({ id: "no_permission" })
            }
            disabled={!canUpdate}
            checked={note.isEnabled}
            onChange={(e) =>
              (canUpdate &&
                updateStatusRequest({
                  id: note.id,
                  status: e.value,
                })) ||
              null
            }
          />
        </div> */}
                          {/* Column 2 - Toggle using SwitchInput */}
                          {/* <div style={{ width: "80px", textAlign: "center" }}>
  <Field
    component={SwitchInput}
    type="checkbox"
    name={`notifications[${note.id}].isEnabled`}
    label="" // no label since name is already in column 1
    disabled={!canUpdate}
    checked={note.isEnabled}
    onChange={(e) => {
      if (canUpdate) {
        updateStatusRequest({
          id: note.id,
          status: e.target.checked, // SwitchInput emits checkbox-style event
        });
      }
    }}
  />
</div> */}

                          <div style={{ width: "80px", textAlign: "center" }}>
                            {/* The tooltip must show on a disabled (always on)
                                switch: a React-owned wrapper carries it, not
                                showOnDisabled, which moves nodes outside React */}
                            <TooltipTarget
                              tooltipOptions={{ position: "bottom" }}
                              tooltip={
                                isAlwaysOn(note)
                                  ? intl.formatMessage({
                                      id: ALWAYS_ON_MESSAGES[note.type],
                                    })
                                  : canUpdate
                                  ? ""
                                  : intl.formatMessage({ id: "no_permission" })
                              }
                            >
                            <InputSwitch
                              disabled={
                              isAlwaysOn(note) || disabldNotification(item.name.toLowerCase(),note.execuationDate) || disabledUserCreationNotificatoin(note.name)
                            //  (!item.name.toLowerCase() === "others" && todaysDate<new Date(note.executionDate))||   !item.name?.toLowerCase() === "others" 
                              }
                              checked={note.isEnabled} // directly from the flat state.data
                              onChange={(e) => {
                                if (canUpdate) {
                                  // update the status in Redux
                                  updateStatusRequest({
                                    id: note.id,
                                    status: e.value,
                                  });
                                }
                              }}

                              // pt={{
                              //   slider: {
                              //     style: {
                              //       backgroundColor: note.isEnabled
                              //         ? "#374151"
                              //         : "#bfc4cfff", // track color
                              //       height: "24.5px", // adjust height
                              //       width: "42px",
                              //     },
                              //   },
                              // }}
                            />
                            </TooltipTarget>
                          </div>
                          {/* Column 3 - Settings */}
                          <div style={{ width: "40px", textAlign: "center" }}>
                            <span
                              data-testid="notification-actions"
                              className="pi pi-ellipsis-v"
                              style={{
                                cursor: "pointer",
                                fontSize: "1.2rem",
                                color: "#666",
                              }}
                              onClick={(e) => {
                                setSelectedNoteId(note.id); // Set the current note id
                                op.current.toggle(e);
                                //op.current.toggle(e, e.currentTarget); // anchor overlay to this icon
                              }} // toggle overlay
                            ></span>
               

                            <OverlayPanel
                              ref={op}
                              appendTo={document.body}
                              className="p-0 edexlms-other-actions-menu-overlay"
                              onClick={(e) => e.stopPropagation()}
                            >
                              {/* Clone and Edit both go through the API's
                                  create or update notification endpoints, so
                                  they are gated the same way a row's other
                                  actions menu is (MoreActions isAllowed),
                                  greyed with the no_permission tooltip
                                  (P-UI-7). */}
                              <Tooltip target=".edexlms-other-actions-menu-item.disabled" />
                              <ul data-testid="row-actions-menu">
                                {selectedOverlay?.name?.toLowerCase() ===
                                  "others" && (
                                  <li
                                    className={classNames(
                                      "edexlms-other-actions-menu-item",
                                      { disabled: !canCreate }
                                    )}
                                    data-pr-tooltip={intl.formatMessage({
                                      id: "no_permission",
                                    })}
                                    data-pr-position="left"
                                    onClick={() => {
                                      if (!canCreate) {
                                        return;
                                      }
                                      navigate(
                                        `${RouteConstants.APP_ROUTE_NOTIFICATIONS_BUILDER_ADD}`,
                                        {
                                          state: {
                                            isEdit: false,
                                            isClone: true,
                                            isCustomEdit: false,
                                            id: selectedNoteId,
                                          },
                                        }
                                      );
                                    }}
                                  >
                                    <span className="pi pi-copy mr-2"></span>
                                    <span>
                                      {intl.formatMessage({ id: "clone" })}
                                    </span>
                                  </li>
                                )}
                                {selectedOverlay?.name?.toLowerCase() !==
                                  "others" && (
                                  // Show Edit option
                                  <li
                                    className={classNames(
                                      "edexlms-other-actions-menu-item",
                                      { disabled: !canUpdate }
                                    )}
                                    data-pr-tooltip={intl.formatMessage({
                                      id: "no_permission",
                                    })}
                                    data-pr-position="left"
                                    onClick={() => {
                                      if (!canUpdate) {
                                        return;
                                      }
                                      navigate(
                                        `${RouteConstants.APP_ROUTE_NOTIFICATIONS_BUILDER_ADD}`,
                                        {
                                          state: {
                                            isEdit: true,
                                            id: selectedNoteId,
                                          },
                                        }
                                      );
                                    }}
                                  >
                                    <span className="pi pi-pencil mr-2"></span>
                                    <span>
                                      {intl.formatMessage({ id: "edit" })}
                                    </span>
                                  </li>
                                )}

                                {selectedOverlay?.name?.toLowerCase() ===
                                  "others" &&
                                  !disabldNotification(
                                    selectedOverlay.name.toLowerCase(),
                                    selectedOverlay.notification
                                      .execuationDate
                                  ) && (
                                    <li
                                      className={classNames(
                                        "edexlms-other-actions-menu-item",
                                        { disabled: !canUpdate }
                                      )}
                                      data-pr-tooltip={intl.formatMessage({
                                        id: "no_permission",
                                      })}
                                      data-pr-position="left"
                                      onClick={() => {
                                        if (!canUpdate) {
                                          return;
                                        }
                                        navigate(
                                          `${RouteConstants.APP_ROUTE_NOTIFICATIONS_BUILDER_CUSTOM_EDIT}`,
                                          {
                                            state: {
                                              isEdit: true,
                                              isClone: false,
                                              isCustomEdit: true,
                                              id: selectedNoteId,
                                            },
                                          }
                                        );
                                      }}
                                    >
                                      <span className="pi pi-pencil mr-2"></span>
                                      <span>
                                        {intl.formatMessage({ id: "edit" })}
                                      </span>
                                    </li>
                                  )}
                              </ul>
                            </OverlayPanel>
                          </div>
                        </div>
                      );
                     }
                    })}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

const mapDispatchToProps = (dispatch) => ({
  listRequest: (params) => dispatch(listRequest(params)),
  updateStatusRequest: (params) => dispatch(updateStatusRequest(params)),
});

const mapStateToProps = (state) => ({
  list: state.notifications?.data,
  requesting: state.notifications.requesting,
  error: state.notifications.error,
  action: state.notifications.action,
  user: state.self?.user,
});

export default connect(mapStateToProps, mapDispatchToProps)(NotificationList);
